// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

import "@fortawesome/fontawesome-free/js/all.min.js"
import "mdb-ui-kit/js/mdb.min.js"
import "styles/application.scss"
require('slim-select/dist/slimselect.css')
require('slim-select/dist/slimselect.min.css')
import "packs/mdb.js"
import bootstrap from 'bootstrap'
import "chartkick/chart.js"

Rails.start()
Turbolinks.start()
ActiveStorage.start()

import "controllers"
require("trix")
require("@rails/actiontext")